export default __webpack_public_path__ + "static/media/8k_earth_normal_map.930cf2e9.jpeg";